module.exports = __webpack_public_path__ + "img/sopi-balaton.500dab1d.png";